import LivedigitalSDKError from './LivedigitalSDKError';

class RequestError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE = 'Request failed';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? RequestError.DEFAULT_MESSAGE, errorCode ?? 'something_went_wrong', meta);
  }
}

export default RequestError;
